// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#quizzes {
  padding: 1rem;
  overflow: auto;
}

#quizzes-catalog-header {
  display: flex;
  justify-content: space-between;
  background-color: var(--white);
  box-shadow: var(--shadow);
  margin-bottom: 1rem;
  padding: 1rem;
  align-items: center;
}

#quizzes-catalog-header h2 {
    font-size: 1.25rem;
    margin: 0;
  }

#quizzes-catalog-header button.highlight {
    background-color: var(--btn-bg-color);
    border: 1px solid var(--border-dark-color);
    color: var(--white);
  }

#quizzes-catalog-header button.highlight:hover {
      background-color: var(--btn-dark-bg-color);
      border: 1px solid var(--border-dark-bg-color);
    }

#quizzes-catalog-header .quizzes-button-group,#quizzes-catalog-header .toggle-btn {
      display: flex;
    }

#quizzes-catalog-header .toggle-btn + .toggle-btn {
      margin-left: 1rem;
    }

#quizzes-catalog-header button {
    background-color: var(--white);
    border: 1px solid var(--border-dark-color);
    color: var(--black);
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }

#quizzes-catalog-header button:hover {
      background-color: var(--grey2);
    }

.quizzes-list-empty {
  display: flex;
  justify-content: center;
  background-color: var(--white);
  box-shadow: var(--shadow);
  padding: 1rem;
}

#quizzes-my-list-header {
  font-size: 1rem;
  color: var(--black);
  margin-bottom: 0.5rem;
}

#quizzes-my-list-header  > h3 {
    background-color: var(--grey1);
    padding: 0.2rem 1rem;
  }
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/QuizCatalog.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AAuCrB;;AArCE;IACE,kBAAkB;IAClB,SAAS;EACX;;AAEA;IACE,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;EAMrB;;AAJE;MACE,0CAA0C;MAC1C,6CAA6C;IAC/C;;AAGF;MAEI,aAAa;IACf;;AAEA;MACE,iBAAiB;IACnB;;AAEF;IACE,8BAA8B;IAC9B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;EAKjB;;AAHE;MACE,8BAA8B;IAChC;;AAIJ;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AAMvB;;AAJE;IACE,8BAA8B;IAC9B,oBAAoB;EACtB","sourcesContent":["@import \"../shared.css\";\r\n\r\n#quizzes {\r\n  padding: 1rem;\r\n  overflow: auto;\r\n}\r\n\r\n#quizzes-catalog-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  margin-bottom: 1rem;\r\n  padding: 1rem;\r\n  align-items: center;\r\n\r\n  & h2 {\r\n    font-size: 1.25rem;\r\n    margin: 0;\r\n  }\r\n\r\n  & button.highlight {\r\n    background-color: var(--btn-bg-color);\r\n    border: 1px solid var(--border-dark-color);\r\n    color: var(--white);\r\n\r\n    &:hover {\r\n      background-color: var(--btn-dark-bg-color);\r\n      border: 1px solid var(--border-dark-bg-color);\r\n    }\r\n  }\r\n\r\n  & .quizzes-button-group,\r\n    .toggle-btn {\r\n      display: flex;\r\n    }\r\n\r\n    .toggle-btn+.toggle-btn {\r\n      margin-left: 1rem;\r\n    }\r\n\r\n  & button {\r\n    background-color: var(--white);\r\n    border: 1px solid var(--border-dark-color);\r\n    color: var(--black);\r\n    font-size: 1rem;\r\n    padding: 0.25rem 0.5rem;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background-color: var(--grey2);\r\n    }\r\n  }\r\n}\r\n\r\n.quizzes-list-empty {\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  padding: 1rem;\r\n}\r\n\r\n#quizzes-my-list-header {\r\n  font-size: 1rem;\r\n  color: var(--black);\r\n  margin-bottom: 0.5rem;\r\n\r\n  > h3 {\r\n    background-color: var(--grey1);\r\n    padding: 0.2rem 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
